import { GenericClassTranslate } from "./genericClass";

export class BalanceEssayType extends GenericClassTranslate {
    active: boolean;
}

export enum BalanceEssayTypeEnum {
    ESSAY_FUNDAMENTAL = 1,
    ESSAY_REPEATABILTY = 2,
    ESSAY_ECCENTRICITY = 3,
    ESSAY_TARE = 4,
    ESSAY_MINIMUM_WEIGHT= 5
}